import { render, staticRenderFns } from "./QuickBIPanelShell.vue?vue&type=template&id=5b694b64&scoped=true&"
import script from "./QuickBIPanelShell.vue?vue&type=script&lang=js&"
export * from "./QuickBIPanelShell.vue?vue&type=script&lang=js&"
import style0 from "./QuickBIPanelShell.vue?vue&type=style&index=0&id=5b694b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b694b64",
  null
  
)

export default component.exports